import { styled } from 'styled-components';

export const Li = styled.li`
  font-style: italic;
  font-weight: bold;
`;
